import React from "react";
import { useNavigate } from "react-router-dom";
import PageNotFoundImage from "assets/images/pageNotFoundImage.png";
import { PrimaryButton } from "widgets";

import styles from "./PageNotFound.module.scss";

const handleOnClickHomePageButton = (navigate) => {
  navigate("/homePage");
};

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.pageNotFound}>
      <img
        src={PageNotFoundImage}
        alt="Page Not Found"
        className={styles.image}
      />
      <h1 className={styles.title}>404 - Page Not Found</h1>
      <p className={styles.description}>
        The page you are looking for does not exist or has been moved.
      </p>
      <PrimaryButton onClick={() => handleOnClickHomePageButton(navigate)}>
        Go to Home Page
      </PrimaryButton>
    </div>
  );
};

export default PageNotFound;
